import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import ShopmyImage from '../General/ShopmyImage';

import './SafeImage.scss';

const getImageKey = source => {
  if (!source) return '';
  const raw = typeof source === 'string' ? source : source.uri || source.url || '';
  // The scrape pipeline stores stringified nulls; rendering them would request literally "/null".
  return raw === 'null' || raw === 'undefined' ? '' : raw;
};

const SafeImage = ({ source, alt, className, placeholderText, errorText, ...props }) => {
  const imageKey = getImageKey(source);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [imageKey]);

  if (!imageKey || failed) {
    return (
      <div className={cn('silent-eval-safe-image-placeholder', className, { 'is-error': failed })}>
        {failed ? errorText : placeholderText}
      </div>
    );
  }

  return (
    <ShopmyImage
      // Retailer CDNs hotlink-protect their product images: with the app's default
      // strict-origin-when-cross-origin policy the request carries our origin as Referer and
      // gets a 403. no-referrer makes the request look like a direct open, which they allow.
      referrerPolicy='no-referrer'
      loading='lazy'
      decoding='async'
      {...props}
      source={source}
      alt={alt}
      className={className}
      onError={e => {
        props.onError?.(e);
        setFailed(true);
      }}
    />
  );
};

SafeImage.propTypes = {
  source: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  alt: PropTypes.string,
  className: PropTypes.string,
  placeholderText: PropTypes.string,
  errorText: PropTypes.string
};

SafeImage.defaultProps = {
  alt: '',
  placeholderText: 'No image',
  errorText: 'Image could not load'
};

export default SafeImage;
